import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "pb-4" }
const _hoisted_3 = { class: "text-title-underline" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  for: "category",
  class: "form-label"
}
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = {
  for: "subject",
  class: "form-label"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "form-error-text" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = {
  for: "body",
  class: "form-label"
}
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "form-error-text" }
const _hoisted_14 = { class: "pt-4 pb-2 flex justify-end" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "内容", -1)
const _hoisted_16 = { class: "px-2 pt-2 pb-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold pt-2" }, "件名", -1)
const _hoisted_19 = { class: "px-2 pt-2 pb-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold pt-2" }, "本文", -1)
const _hoisted_22 = {
  style: {"white-space":"pre-wrap","word-wrap":"break-word"},
  class: "px-2 pt-2 pb-1"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = { class: "flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_faq = _resolveComponent("contact-faq")!
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_base_form_select = _resolveComponent("base-form-select")!
  const _component_base_form_submit = _resolveComponent("base-form-submit")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_contact_faq)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_base_alert, { class: "mt-2 mb-4" }),
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t('contact.title')), 1),
              _createElementVNode("form", {
                onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t('word.contents')), 1),
                  _createVNode(_component_base_form_select, {
                    class: "mb-1",
                    selectedVal: _ctx.contact_category_id,
                    "onUpdate:selectedVal": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contact_category_id) = $event)),
                    options: _ctx.store.state.contact.category
                  }, null, 8, ["selectedVal", "options"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.t('word.subject')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.subject) = $event)),
                    id: "subject",
                    name: "subject",
                    type: "text",
                    placeholder: _ctx.t('word.subject'),
                    class: _normalizeClass(`form-input mb-1 ${_ctx.errors['subject'] ? 'border-red-500' : ''}`)
                  }, null, 10, _hoisted_8), [
                    [_vModelText, _ctx.subject]
                  ]),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.errors['subject']), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t('word.body')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body) = $event)),
                    id: "body",
                    name: "body",
                    placeholder: _ctx.t('word.body'),
                    class: _normalizeClass(`form-input mb-1 ${_ctx.errors['body'] ? 'border-red-500' : ''}`),
                    rows: 5
                  }, null, 10, _hoisted_12), [
                    [_vModelText, _ctx.body]
                  ]),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.errors['body']), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "bg-blue-500 hover:bg-blue-400 text-white py-1.5 px-4 rounded disabled:opacity-75",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDialog()))
                  }, "確認")
                ]),
                _createVNode(_component_el_dialog, {
                  modelValue: _ctx.dialogVisible,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogVisible) = $event)),
                  title: "確認画面",
                  width: "90%"
                }, {
                  footer: _withCtx(() => [
                    _createElementVNode("span", _hoisted_24, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "bg-gray-200 hover:bg-gray-300 text-gray-800 py-1.5 px-4 rounded disabled:opacity-75 mr-2",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogVisible = false))
                      }, "キャンセル"),
                      _createVNode(_component_base_form_submit, { disabled: _ctx.btnDisabled }, null, 8, ["disabled"])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.selectCategory()), 1),
                      _hoisted_17
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.subject), 1),
                      _hoisted_20
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.body), 1),
                      _hoisted_23
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ], 32)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}